module.exports = __webpack_public_path__ + "img/bitcoin-white.82a50a3f.png";